import * as actionTypes from '../../constants/actionTypes';

export const addPaginatedResource = (requestInfo, relatedType) => ({
  type: actionTypes.WAIT_PAGINATED_RESPONSE,
  requestInfo,
  relatedType,
});

export const clearPaginatedResource = (paginatedResource, resourceType, id) => ({
  type: actionTypes.CLEAR_PAGINATED_RESPONSE,
  paginatedResource,
  resourceType,
  id,
});
